import { MdShoppingCart } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddToCart } from "../Redux/Action";
import "./Body.css";

function Apiproduct({ proData, setProData }) {
  const dispatch = useDispatch();

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="colored"
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div
        className="product-mainsec"
        style={{ backgroundColor: "white", paddingTop: "20px" }}
      >
        {proData ? (
          proData?.map((item, index) => {
            return (
              <div
                key={item?.barcode}
                className="product_container1"
                style={{ backgroundColor: "#ffffff" }}
              >
                {item.promoPercentage ? (
                  <span className="discount-offers">
                    {" "}
                    {item.promoPercentage}% OFF
                  </span>
                ) : (
                  ""
                )}
                <Link
                  to={"/productdetail"}
                  state={{ item }}
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  <img
                    src={`${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`}
                  />
                </Link>

                <p>{item.description}</p>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <span className="cr-price">
                    Rs.&nbsp;
                    {item?.promoPercentage
                      ? Math.round(
                          item?.unitRetail -
                            (item?.unitRetail * item?.promoPercentage) / 100
                        )
                      : item?.unitRetail}
                  </span>
                  {item?.promoPercentage > 0 ? (
                    <del className="cr-price" style={{ color: "red" }}>
                      Rs. {item?.unitRetail}
                    </del>
                  ) : item?.marketRetail > item?.unitRetail ? (
                    <del className="cr-price" style={{ color: "red" }}>
                      Rs. {item?.marketRetail}
                    </del>
                  ) : null}
                </div>

                <div className="product-cart">
                  <div className="product-cart1"></div>
                  <div className="product-cart2">
                    <button
                      onClick={() => {
                        dispatch(AddToCart(item));
                        toast.success("Product Added Successfully", {
                          position: "top-center",
                          autoClose: 1000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                      }}
                    >
                      <MdShoppingCart />
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <ClipLoader color={"red"} loading={true} size={100} />
        )}
      </div>
    </>
  );
}

export default Apiproduct;
